import { ReviewCell } from '../../components/ReviewCell'
import { useNavigate } from 'react-router-dom'
import {
  useCurrentUserReviews,
  type IReviewWithFragrance,
} from '../../queries/useReviews'

export const MyReviewsView = () => {
  const navigate = useNavigate()
  const { data: reviewsData, isLoading } = useCurrentUserReviews()
  const reviews = reviewsData?.items ?? []

  const formatTimestamp = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date()
    const diffMs = now.getTime() - date.getTime()
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMs / 3600000)
    const diffDays = Math.floor(diffMs / 86400000)
    const diffWeeks = Math.floor(diffMs / 604800000)

    if (diffMins < 60) {
      return diffMins <= 1 ? 'Just now' : `${diffMins} minutes ago`
    } else if (diffHours < 24) {
      return diffHours === 1 ? '1 hour ago' : `${diffHours} hours ago`
    } else if (diffDays < 7) {
      return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`
    } else if (diffWeeks < 4) {
      return diffWeeks === 1 ? '1 week ago' : `${diffWeeks} weeks ago`
    } else {
      return date.toLocaleDateString()
    }
  }

  const handleReviewClick = (review: IReviewWithFragrance) => {
    if (review.fragranceSlug) {
      navigate(`/fragrance/${review.fragranceSlug}`)
    }
  }

  return (
    <div className={'flex flex-col h-full'}>
      {/* Fixed Header */}
      <div
        className={
          'flex items-center justify-between px-4 md:px-8 pb-6 pt-8 border-b border-searchBorder'
        }
      >
        <h2 className={'text-xl font-semibold'}>My Reviews</h2>

        <span className={'text-gray-600'}>
          {isLoading ? '...' : `${reviews.length} review${reviews.length !== 1 ? 's' : ''}`}
        </span>
      </div>

      {/* Scrollable List */}
      <div className={'flex-1 overflow-y-auto pr-2 scrollbar-hide-track'}>
        {isLoading ? (
          <div className={'flex items-center justify-center py-12'}>
            <div className={'text-gray-500'}>Loading...</div>
          </div>
        ) : reviews.length === 0 ? (
          <div className={'flex items-center justify-center py-12'}>
            <div className={'text-gray-500'}>
              No reviews yet
            </div>
          </div>
        ) : (
          reviews.map((review) => (
            <ReviewCell
              key={review.id}
              imageUrl={review.fragranceImage || 'https://via.placeholder.com/150'}
              title={review.fragranceName}
              rating={review.rating}
              reviewText={review.text}
              timestamp={formatTimestamp(review.created)}
              onClick={() => handleReviewClick(review)}
            />
          ))
        )}
      </div>
    </div>
  )
}
